import { EntityList } from '@avangard/utils/entity';
import { SchoolProfileSectionEntity } from './school-profile-section-entity';

import type { Entity } from './school-profile-section-entity';

class SchoolProfileSectionEntityList extends EntityList<SchoolProfileSectionEntity> {
    constructor(items: Entity[] | null, count?: number | null) {
        super(SchoolProfileSectionEntity, items, count);
    }
}

export { SchoolProfileSectionEntityList };
